export default "__VITE_ASSET__TZ2pDTup__"